var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heart-sound-check"},[_c('md-chip',{staticClass:"md-primary"},[_vm._v("If heart sound was checked")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }